<template lang="pug">
    div#products-view
        MainHeader
        div.box
            div.has-text-centered
                strong.title Products
            hr

            div
                strong.subtitle Under Construction..
            div.fill-space
        Footer
        //- div.box
            div.has-text-centered
                strong.title Products
            hr

            div 
                strong.subtitle Arcade Game
                div img
                div Κονσόλα arcade και retro παιχνιδιών για 1 ή 2 παίχτες. 
                |   Συλλογή όλων των κλασσικών παιχνιδιών της δεκαετίας 80-90, όπως arcade games, Nintendo, Sega, Atari (c) κτλ.
            hr
            
            div
                strong.subtitle Talos Home
                div img
                div Σύστημα συναγερμού για εξοχικά, αποθήκες, τροχόσπιτα, σκάφη και απομακρυσμένους χώρους, χωρίς τηλεφωνική γραμμή. 
            hr

            div
                strong.subtitle Talos Industrial
                div img
                div Βιομηχανικό σύστημα επιτήρησης χώρου και ανίχνευσης πυρκαγιάς και πλημμύρας.
            hr

            div 
                strong.subtitle RFID 
                div img
                div Ολοκληρωμένο σύστημα διαχείρισης πελατών και ραντεβού με χρήση τεχνολογίας RFID. 
                | Το σύστημα παραμετροποιείται για να εξυπηρετεί οποιαδήποτε επιπλέον ανάγκη και χώρο. 
                | Ενδείκνυται για γυμναστήρια, στούντιο Pilates, στούντιο Yoga, σχολές χορού, χώρους αισθητικής, 
                | φυσιοθεραπευτήρια, και οποιοδήποτε χώρο παρέχει υπηρεσία και λειτουργεί με ραντεβού.
                        
</template>

<script>
import MainHeader from "@/components/MainHeader.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: 'products',
  components: {
    MainHeader,
    Footer
  }  
}
</script>

<style scoped>
.box {
    background-color: #E8E8E8;
}

hr {
    border-bottom-style: solid;
    border-bottom-color: rgb(111, 111, 111);
    border-bottom-width: 1px;
    border-bottom-width: 80%;
    margin-bottom: 2rem;

}

.fill-space {
    margin-bottom: 25vh;
}
</style>
